import { DEFAULT_COUNTRY } from "@stadium/helpers/country/constants";

import { CE_01, DEFAULT } from "@helpers/plasmic/slices";

import { CATALOG_HOME_LINK_TYPE } from "@stadium/shared/src/constants/stores/routes";

export const DEFAULT_CATALOG_ENTRIES_PROPS = {
  countryCode: DEFAULT_COUNTRY.iso,
  btnLinkType: CATALOG_HOME_LINK_TYPE,
  variant: CE_01,
  showSubcategories: false,
  viewType: DEFAULT,
  hideCategories: [],
  orderCategories: [],
  linkToNewTab: false,
  customCategories: [],
  controlContextData: {
    slugs: [],
    renderedSlugs: [],
    categorySlugs: [],
  },
};

export const BRAND_VISIBLE_BRAND_COUNT = 18;
